import styled from 'styled-components';

export const OptionContainer = styled.div`
    display: flex;
    max-width: 100%;
    overflow-x: auto;

    img {
        vertical-align: top;
    }
`;

export const Wrapper = styled.div`
    display: inline-grid;

    grid-gap: 16px;
    grid-template-columns: ${(props) => (props.direction === 'vertical' ? '1fr' : '1fr 1fr 1fr')};
    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export const Index = styled.div`
    font-size: 16px;
    font-weight: 600;
    margin: 9px 8px 0 0;
    flex-shrink: 0;
    white-space: nowrap;
`;
